module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_1_0@2x.c9ae218b.png";